import { useState, useEffect } from 'react';
// import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
import breadcrumbConfig from "../../assets/breadcrumbConfigs.json";
import { useLocation } from "react-router-dom";
import isNullOrUndefined from '../functions/isNullOrUndefined';
import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { createTheme, ThemeProvider, Typography } from '@mui/material';
// import '../../css/pageStyle.css';
  const theme = createTheme({
    components: {
      MuiMenuItem: {
        styleOverrides: {
          root: {
            "&.MuiMenuItem-root": {
              padding: "4px"
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            "&.MuiPaper-rounded" :{
                "border-radius": "2px"
              }
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            "&.MuiList-root": {
              padding: 0 ,
              margin: "4px ",
            },
          },
        },
      },
    },
  });
   
const PageBreadcrumbs = () => {
    // initialize state
    const [crumbs, setCrumbs] = useState([]);
    const [showMoreIcon, setShowMoreIcon] = useState(false);
    const [menuItems, setMenuItems] = useState([]);
    // init useLocation
    var location = useLocation();
 
    // useEffect to run on location change
    useEffect(() => {
        // get parent links from config
        let parents = [];
        let parentsTemp = []
        if (!isNullOrUndefined(breadcrumbConfig[location.pathname])
            && !isNullOrUndefined(breadcrumbConfig[location.pathname]['parents'])
        ) {
 
            parents = breadcrumbConfig[location.pathname]['parents'];
            if (parents.length > 1) {
                setShowMoreIcon(true);
                parentsTemp.push(parents[parents.length - 1]);
                setMenuItems(items => items = parents.slice(0, -1));
 
            } else {
                setShowMoreIcon(false);
                parentsTemp = parents;
                setMenuItems(items => items = []);
            }
        }
        // set crumbs for render
        setCrumbs(crumbs => crumbs = parentsTemp);
    }, [location]);
 
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
 
    const handleClick = (event) => {
        if (event) {
            setAnchorEl(event.currentTarget);
        }
    };
 
    const handleClose = () => {
        setAnchorEl(null);
    };
    // render breadcrumbs
    return (
        <ThemeProvider theme={theme} >
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                aria-labelledby="with-menu-demo-breadcrumbs"
            >
                {menuItems.map(pathname => {
                    // return if there is no object for link
                    if (isNullOrUndefined(breadcrumbConfig[pathname])) {
                        return;
                    }
                    // return link
                    return (
                        <div className="menu-item">
 
                            <Link
                                to={{
                                    pathname: breadcrumbConfig[pathname]['link'],
                                }}
                            >
 
                                <MenuItem onClick={handleClose}><Typography sx={{ fontSize: '16px', color: '#0295BE' }} >{breadcrumbConfig[pathname]['label']}</Typography></MenuItem>
                            </Link>
                        </div>
                    )
                })}
            </Menu>
            <div style={{ display: 'flex' }}>
                {showMoreIcon ? <IconButton sx={{ color: '#54585A' }} size="small" onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton> : null}
                <Breadcrumbs separator=">" aria-label="breadcrumb" sx={{ alignSelf: 'center' }}>
 
                    {crumbs.map(pathname => {
                        // return if there is no object for link
                        if (isNullOrUndefined(breadcrumbConfig[pathname])) {
                            return;
                        }
                        // return link
                        return (
                            <div>
 
                                <Link
                                    to={{
                                        pathname: breadcrumbConfig[pathname]['link'],
                                    }}
                                >
 
                                    <Typography sx={{ fontSize: '16px', color: '#0295BE', textDecorationColor: '#0295BE', textDecoration: 'underline' }}>{breadcrumbConfig[pathname]['label']} </Typography>
                                </Link>
                            </div>
                        )
                    })}
                    {!isNullOrUndefined(breadcrumbConfig[location.pathname]) ?
                        <Typography sx={{ fontSize: '16px', color: '#001317' }}>{breadcrumbConfig[location.pathname]['label']}</Typography>
                        : <div></div>}
 
                </Breadcrumbs>
            </div>
        </ThemeProvider>
    );
}
 
export default PageBreadcrumbs;